import { Divider, makeStyles, mergeClasses, shorthands, tokens, Text } from '@fluentui/react-components';
import { FC, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IGptConfiguration } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { useGptConfigurations } from '../../store/hooks';
import AppLogoWithTitle from '../Common/AppLogoWithTitle';
import { AppMenuContent } from './AppMenuContent';
import { appConfig } from '../../AppConfig';
import { useUserContext } from '../../Contexts/UserContext';
import { SettingsMenuContext } from '../../Contexts/SettingsMenuContext';
import SettingsMenu from './SettingsMenu';
import { useIsMobile } from '../../Hooks/useResponsive';
import SyButton from '../Common/SyButton';
import { MessagesSquare } from 'lucide-react';
import MenuBottomZone from './MenuBottomZone';

const useStyles = makeStyles({
    root: {
        display: 'grid',
        gridTemplateRows: '1fr',
        height: '100%',
        boxSizing: 'border-box',
        backgroundColor: tokens.colorNeutralBackground1,
        width: '100%',
        position: 'relative',
        // Ensure no horizontal scrollbar appears
        overflowX: 'hidden',
        overflowY: 'hidden',

        letterSpacing: 'normal',
    },
    rootExpanded: {
        padding: '20px 12px 0 18px', // top, right, bottom, left 
        placeItems: 'center',
    },
    rootCollapsed: {
        ...shorthands.padding(tokens.spacingVerticalM, '0'),
        placeItems: 'center',
    },
    content: {
        display: 'grid',
        gridTemplateRows: 'auto 1fr',
        boxSizing: 'border-box',
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        minHeight: 0,
        gridRow: '1',
        paddingBottom: 0,
        marginBottom: 0,
    },
    smallDivider: {
        height: '1.5rem',
    },
    
});

interface AppMenuProps {
    onNewChat: (gptConfiguration: IGptConfiguration) => void;
}

const AppMenu: FC<AppMenuProps> = ({onNewChat}) => {
    const classes = useStyles();
    const { userProfile } = useUserContext();
    const { isInSettings } = useContext(SettingsMenuContext);
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const { gptConfigurations } = useGptConfigurations();
    const addedGpts = gptConfigurations || [];
    const gpt = addedGpts.find(g => g.isDefault) || addedGpts[0];

    // If in settings mode, render the SettingsMenu instead
    if (isInSettings) {
        return <SettingsMenu />;
    }

    // Otherwise, always render the expanded full menu
    return (
        <div
            className={mergeClasses(
                classes.root,
                classes.rootExpanded                
            )}
        >
            <div className={classes.content}>
                <AppMenuContent onNewDraftChat={onNewChat} />
            </div>

            <div style={{ width: '100%' }}>
                <MenuBottomZone />
            </div>            
        </div>
    );
};

export default AppMenu;
